import template from './user-profile-completeness.html';
import userProfileCompletenessController from './user-profile-completeness.controller';
import './user-profile-completeness.styl';

let userProfileCompletenessComponent = {
  restrict: 'E',
  bindings: {
    profileItems: '<',
    isClient: '<',
    clientInfo: '<',
    providerInfo: '<',  
    userId: '<', 
  },
  template,
  controller: userProfileCompletenessController,
  controllerAs: 'vm'
};

export default userProfileCompletenessComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-profile-completeness/user-profile-completeness.component.js
 **/